/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { createContext, useContext, useReducer } from 'react';
import fileUploadReducer from './FileUploadReducer';
import { IAny } from '../../components/DashboardKPIWidgets/IEnergyManagementProps';

export interface IFileUploadState {
  showModal: boolean;
  showPublishModal: boolean;
  acceptedFiles: File[];
  acceptedCsvHeaders: string[];
  showZLOModal?: boolean;
  zloFile?: File | null;
  showAddFuelModal?: boolean;
  isEditButtonEnabled?: boolean;
  requestContext?: IAny;
}

const initialState: IFileUploadState = {
  showModal: false,
  showPublishModal: false,
  acceptedFiles: [],
  acceptedCsvHeaders: [],
  showZLOModal: false,
  zloFile: null,
  showAddFuelModal: false,
  isEditButtonEnabled: true,
  requestContext: []
};

export const FileUploadContext = createContext<IAny>(initialState);

export const FileUploadProvider: React.FC<{}> = ({ children }) => {
  const [state, dispatch] = useReducer(fileUploadReducer, initialState);

  const value: IAny = [state, dispatch];

  return (
    <FileUploadContext.Provider value={value}>
      {children}
    </FileUploadContext.Provider>
  );
};

export const useFileUploadContext = () => useContext(FileUploadContext);
